export interface GameClock {
  now(): Date;
}

export class SystemGameClock implements GameClock {
  now(): Date {
    return new Date();
  }
}

export class FixedGameClock implements GameClock {
  constructor(private current: Date) {}

  now(): Date {
    return this.current;
  }

  advance(ms: number): void {
    this.current = new Date(this.current.getTime() + ms);
  }
}
